import { CoachingProfileView } from '@euler/model/coaching-progress';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

/** 我的练习's profile: the radar, stars per case and level, milestones. */
export function useCoachingProfile() {
  const { coachingService } = useServiceFactory();
  const [profile, setProfile] = useState<CoachingProfileView | null>(null);
  const [failed, setFailed] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    coachingService
      .getProfile()
      .then(value => {
        if (!active) return;
        setProfile(value);
        setFailed(false);
      })
      .catch(error => {
        console.error('coaching profile failed', error);
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [coachingService, reloadKey]);
  return { profile, failed, reload };
}
